import { HttpClient } from '@angular/common/http';
import { Component, Inject, Input, OnInit, Output, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from
    "@angular/forms"
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';
import { SpinnerOverlayService } from '../../../../services/spinner-overlay.service';
import { AddGroupDialogue } from '../../home/edituser/addgroupdialogue/addgroupdialogue.component';
import { UMPCategory, Utils } from '../../../../utils/utils';
import { DefaultValuesService } from '../../../../services/defaultvalues.service';





@Component({
    selector: "group-mersygroups",
    templateUrl: './mersygroups.component.html',
    styleUrls: ['./mersygroups.component.less'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})

export class GroupMersyGroups implements OnInit {
    @Input() public isMQRequest: boolean | undefined;
    @Input() public isNiOpsRequest: boolean | undefined;
    @Input() public isTaxRequest: boolean | undefined;
    @Input() public isSafetySystemExcellenceRequest: boolean | undefined;
    @Input() public isINCORequest: boolean | undefined;
    @Input() public isBranchExcellenceRequest: boolean | undefined;
    @Input() public isAdminRequest: boolean | undefined;
    
    public userName: String = '';
    userId = ''
    dataCopy: any;
    
    searchString: string = '';
    filteredMersyGroups: any[] = [];

    MersyGroups = [];
    Response_State: number = -2; //0 -> empty , 1 -> correct and not empty ,-1 -> error, -2 -> Calling API
    errorResponse: any;
    isCallSucceed: number = 0;

    @ViewChild(MatSelectionList) selectionList!: MatSelectionList;

    dialogRef: MatDialogRef<AddGroupDialogue, any> | undefined

    AllAzDevProj = [];
    UserAzDevProj = [];
    RemainAzDevProj = [];


    

    constructor(
        private route: ActivatedRoute,
        private http: HttpClient,
        private toastrService: ToastrService,
        private dialogForm: MatDialog,
        private spinnerOverlayService: SpinnerOverlayService,
        private defaults: DefaultValuesService,

   
        @Inject('BASE_URL') private baseUrl: string
    ) {

        this.updateRolesResults();

        this.userId = this.route.snapshot.paramMap.get('userId') || '';
        

        
        this.funcGetMersyGroups();
        defaults.resetBulkGroupTrigger$.subscribe(() => this.resetData())

        
    }

    ngOnInit() {

    }
    updateRolesResults() {
        this.filteredMersyGroups = this.searchByValue(this.MersyGroups, "persona", this.searchString);
    }

    isGroupSelected(item): boolean {
        return this.defaults.groupList.some(group =>
            group.Id === item.id && group.UmpCategory === UMPCategory.MersyGroupFunctions
        );
    }

    searchByValue(items:any,filterProperty:string,query:string) {
        
        return items.filter(item => {
            if (query.trim() === '') {
                return true;
            } else {
                const itemValue = item[filterProperty].toLowerCase();
                const normalizedItemValue = itemValue.replace(/\s+/g, '');
                const searchQuery = query.trim().toLowerCase();
                const normalizedSearchQuery = searchQuery.replace(/\s+/g, '');
                
                return itemValue.includes(searchQuery) || normalizedItemValue.includes(normalizedSearchQuery);
            }
        })   
    }
    
    funcGetMersyGroups() {
        this.Response_State = -2;
        Utils.httpGetMersyGroups(
            this.http
            , this.baseUrl
            , this.userId
            , this
            , function (tthis: GroupMersyGroups, data: any) {
                tthis.dataCopy = structuredClone(data)
                tthis.assignValues(data)
            }
        )
    }
    assignValues(data) {
        if (this.isAdminRequest) {
            this.MersyGroups = data.personae;
        } else {
            this.MersyGroups = data.personae.filter(obj => this.shouldIncludePersona(obj.persona));
        }
        this.updateRolesResults();

        if (this.MersyGroups?.length) {
            this.Response_State = 1;
        }
        else {
            this.Response_State = 0;

        }
    }

    private shouldIncludePersona(persona: string): boolean {
        const normalizedPersona = persona.toLowerCase().replace(/\s+/g, '');
        
        const isMQY = normalizedPersona === "mqy";
        const isEOX = normalizedPersona === "eox";
        const isTax = normalizedPersona === "tax";
        const isSSX = normalizedPersona === "ssx";
        const isINCO = normalizedPersona === "inco";
        const isGBE = normalizedPersona === "gbe";
        
        if (this.isMQRequest || this.isNiOpsRequest || this.isTaxRequest || this.isSafetySystemExcellenceRequest || 
            this.isINCORequest || this.isBranchExcellenceRequest) {
            return !!(this.isMQRequest && isMQY) ||
                   !!(this.isNiOpsRequest && isEOX) ||
                   !!(this.isTaxRequest && isTax) ||
                   !!(this.isSafetySystemExcellenceRequest && isSSX) ||
                   !!(this.isINCORequest && isINCO) ||
                   !!(this.isBranchExcellenceRequest && isGBE);
        }
        
        return !isMQY && !isEOX && !isTax && !isSSX && !isINCO && !isGBE;
    }
    resetData() {
        this.selectionList?.deselectAll();
        this.searchString = '';
        this.assignValues(structuredClone(this.dataCopy))
    }

    funcNotify(persona) {
        if (this.isCallSucceed === 1) {
            this.toastrService.success('Delete "' + persona + '"  request sent successfully !', 'Max Role Delete Request!');
        }
        else if (this.isCallSucceed === -1) {
            this.toastrService.error('Delete "' + persona + '"  request not sent successfully !', 'Max Role Delete Request!');
        }
    }
    itemSelected(event) {
        if (event.options[0]._selected) {
            this.onSelect(event.options[0]._value);
        } else {
            this.onDeselect(event.options[0]._value);
        }
    }

    onSelect(selectedItem) {
        this.defaults.addGroupListItem({ Personae: selectedItem.persona, Id: selectedItem.id, UmpCategory: UMPCategory.MersyGroupFunctions });

    }

    onDeselect(selectedItem) {
        this.defaults.removeGroupListItem(selectedItem.id);

    }

   
}